export const enums: Record<string, Record<string, string>> = {};
